import { gql } from '@apollo/client'
import FamilyMembers from '@/fragments/FamilyMemberFragment'

export default gql`
  query FamilyMembers {
    ...familyMembers
  }
  ${FamilyMembers}
`
